import * as angular from 'angular';
import InterceptorsModule from '../../core/interceptors/interceptors.module';
import nvBuildsModule from '../../core/nv.builds.module';
import { CreditGapsPriorityGroupingsTransferService } from './credit-gaps-priority-groupings/credit-gaps-priority-groupings-transfer.service';
import { CreditGapsPriorityGroupingsService } from './credit-gaps-priority-groupings/credit-gaps-priority-groupings.service';
import CustomExceptionHandlerService from './custom-exception-handler/custom-exception-handler.service';
import { PusherDOMHelper } from './pusher-dom-helper/pusher-dom-helper.service';
import { RegentsPlanningPriorityGroupingsTransferService } from './regents-planning-priority-groupings/regents-planning-priority-groupings-transfer.service';
import { RegentsPlanningPriorityGroupingsService } from './regents-planning-priority-groupings/regents-planning-priority-groupings.service';
import { RegentsPrepPriorityGroupingsTransferService } from './regents-prep-priority-groupings/regents-prep-priority-groupings-transfer.service';
import { RegentsPrepPriorityGroupingsService } from './regents-prep-priority-groupings/regents-prep-priority-groupings.service';
import { SdcWizardStepperService } from './sdc/sdc-wizard-stepper.service';
import { StoreListenerUtilsModule } from './store-listener-utils/store-listener-utils.module';
import { SupportAttendanceService } from './support-attendance/support-attendance.service';
import { WizardUtils } from './wizard-utils/wizard-utils.service';

export default angular
  .module('nv.shared.services', [
    'nv.shared.services.shared-state',
    'nv.shared.services.utils',
    'nv.shared.services.sorter',
    'nv.shared.services.support-schedule',
    InterceptorsModule,
    nvBuildsModule,
    StoreListenerUtilsModule,
  ])
  .service('SdcWizardStepperService', SdcWizardStepperService)
  .service('CreditGapsPriorityGroupingsService', CreditGapsPriorityGroupingsService)
  .service('CreditGapsPriorityGroupingsTransferService', CreditGapsPriorityGroupingsTransferService)
  .service('RegentsPlanningPriorityGroupingsService', RegentsPlanningPriorityGroupingsService)
  .service('RegentsPlanningPriorityGroupingsTransferService', RegentsPlanningPriorityGroupingsTransferService)
  .service('RegentsPrepPriorityGroupingsService', RegentsPrepPriorityGroupingsService)
  .service('RegentsPrepPriorityGroupingsTransferService', RegentsPrepPriorityGroupingsTransferService)
  .service('WizardUtils', WizardUtils)
  .service('PusherDOMHelper', PusherDOMHelper)
  .service('$exceptionHandler', CustomExceptionHandlerService)
  .service('SupportAttendanceService', SupportAttendanceService).name;
